var map = {
	"./calendar.svg": "6bca",
	"./coupon.svg": "e54b",
	"./engine.svg": "3d5b",
	"./invoice.svg": "cfff",
	"./mobile.svg": "efa7",
	"./moedas.svg": "f947",
	"./money.svg": "0938",
	"./nota-fiscal.svg": "bbe3",
	"./pix.svg": "9ce2",
	"./qr-code.svg": "a8a4",
	"./robot (1).svg": "e4bd",
	"./robot.svg": "b023",
	"./uil-file-graph.svg": "0175"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";